import React, { Component } from 'react'

class Footer extends Component {
  constructor (props) {
    super(props)
    this.state = {
    }
  }

  componentWillMount () {

  }

  render () {
    return (
      <footer className='footer'>
        <div className='container'>
          <div className='content has-text-centered'>
            <p>
              <strong>Comparte.500latam.co</strong> hecho con <i className='fa fa-heart' /> por <a href='https://500.co/latam'>500 Latam</a>.
            </p>
            <p>
              <a className='icon' href='javascript:window.location="https://comparte.500latam.co/post?u="+encodeURIComponent(document.location)+"&t="+encodeURIComponent(document.title)'>
                Bookmarklet
              </a>
            </p>
          </div>
        </div>
      </footer>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ../frontend/components/footer.js